export const MAX_FILE_SIZE_MB = 5_000; // 5GB
export const MAX_DIRECT_UPLOAD_SIZE_MB = 5;
export const MAX_FILES_DROP = 10;
